import { Component } from '@angular/core';
import { IgxCircularProgressBarComponent } from '@infragistics/igniteui-angular/progressbar';

/**
 * ロード中のスピナーを表示するComponent
 */
@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [IgxCircularProgressBarComponent],
})
export class PcTabletLoadingSpinnerComponent {
  constructor() {}
}
